import {
    GESTION_OPERATIVA_ADD_PAYMENT_BEGIN,
    GESTION_OPERATIVA_ADD_PAYMENT_SUCCESS,
    GESTION_OPERATIVA_ADD_PAYMENT_ERROR
} from '../constants'
import { ACTION_STATE } from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
        case GESTION_OPERATIVA_ADD_PAYMENT_BEGIN:
            return {
                ...state,
                addPaymentState: ACTION_STATE.PENDING
            }
        case GESTION_OPERATIVA_ADD_PAYMENT_SUCCESS:
            return {
                ...state,
                addPaymentState: ACTION_STATE.SUCCESS,
                urlAddPayment: action.data.urlAddPayment
            }
        case GESTION_OPERATIVA_ADD_PAYMENT_ERROR:
            return {
                ...state,
                addPaymentState: ACTION_STATE.ERROR
            }
        default:
            return state
    }
}